module.exports = __webpack_public_path__ + "img/cross-resonance.cfc2a46b.svg";